import React from "react";
import { FileText, Lock, Scale } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const principles = [{
  title: "Şeffaflık",
  description: "Müvekkillerimizle kurduğumuz ilişkide her adımda açık ve anlaşılır olmayı esas alıyoruz. Hukuki süreçlerin yönetimi, risk analizi ve bilgilendirme aşamalarında tam şeffaflık sağlayarak güvene dayalı bir iş birliği yürütüyoruz.",
  icon: FileText
}, {
  title: "Gizlilik",
  description: "Müvekkil mahremiyeti en temel önceliğimizdir. Paylaşılan tüm bilgi ve belgeler, Avukatlık Kanunu ve KVKK kapsamında en üst düzey güvenlik önlemleriyle korunmakta olup, üçüncü kişilerle asla paylaşılmamaktadır.",
  icon: Lock
}, {
  title: "Hukuka ve Etiğe Uyumluluk",
  description: "Mesleki faaliyetlerimizi, hukukun üstünlüğü ilkesine, Türkiye Barolar Birliği meslek kurallarına ve evrensel etik değerlere tam uyum içinde yürütüyoruz. Adalet arayışında dürüstlükten ödün vermeden hizmet sunuyoruz.",
  icon: Scale
}];
export default function CorporatePrinciplesAndEthicalValues() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="kurumsal-ilkeler-ve-etik-değerler" className="dark bg-[#0B1221] text-foreground py-20 border-y border-white/5 relative overflow-hidden">
      <div className="container mx-auto px-4 max-w-7xl">
        <div ref={ref} className={cn("grid grid-cols-1 md:grid-cols-3 gap-12 transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
          {principles.map((item, i) => <div key={i} data-index={i} className="flex flex-col items-start space-y-4 group">
              <div className="p-3 rounded-full bg-[#967B4F]/10 text-[#967B4F] ring-1 ring-[#967B4F]/30 group-hover:bg-[#967B4F]/20 group-hover:ring-[#967B4F]/50 transition-colors duration-300">
                <item.icon strokeWidth={1.5} className="w-6 h-6" />
              </div>
              
              <h3 className="text-xl font-serif font-medium tracking-tight text-slate-300">
                {item.title}
              </h3>
              
              <p className="text-muted-foreground text-sm leading-relaxed font-sans">
                {item.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}